import React from 'react';

import logo from '../../assets/logo.svg';

import {
  Container,
  FormContent,
  FormSide,
  Hero,
  HeroBrand,
  HeroContent,
  HeroEyebrow,
  HeroSubtitle,
  HeroTitle,
  MobileBrand,
} from './styles';

interface AuthLayoutProps {
  eyebrow: string;
  title: React.ReactNode;
  subtitle: string;
  wide?: boolean;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  eyebrow,
  title,
  subtitle,
  wide = false,
  children,
}) => {
  return (
    <Container>
      <Hero>
        <HeroBrand>
          <img src={logo} alt="Logo TrenzoX" />
          <span>TrenzoX</span>
        </HeroBrand>
        <HeroContent>
          <HeroEyebrow>{eyebrow}</HeroEyebrow>
          <HeroTitle>{title}</HeroTitle>
          <HeroSubtitle>{subtitle}</HeroSubtitle>
        </HeroContent>
      </Hero>
      <FormSide>
        <FormContent wide={wide}>
          <MobileBrand>
            <img src={logo} alt="Logo TrenzoX" />
            <span>TrenzoX</span>
          </MobileBrand>
          {children}
        </FormContent>
      </FormSide>
    </Container>
  );
};

export { AuthLayout };
